export default __webpack_public_path__ + "static/kontrast-4bbd2e36ceca55e112838d044e23313c.png";